// Shared CP-4 ticket constants for both customer and admin UIs.
export const TICKET_STATUSES = [
  { value: "open", label: "Open" },
  { value: "in_progress", label: "In Progress" },
  { value: "waiting_on_customer", label: "Waiting on Customer" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
];

export const TICKET_CATEGORIES = [
  { value: "billing", label: "Billing" },
  { value: "card_issue", label: "Card Issue" },
  { value: "transaction_discrepancy", label: "Transaction Discrepancy" },
  { value: "driver_unit_change", label: "Driver / Unit Change" },
  { value: "price_list_question", label: "Price List Question" },
  { value: "general_support", label: "General Support" },
];

export function ticketStatusLabel(value) {
  const s = TICKET_STATUSES.find((s) => s.value === value);
  return s ? s.label : value;
}

export function ticketCategoryLabel(value) {
  const c = TICKET_CATEGORIES.find((c) => c.value === value);
  return c ? c.label : value;
}

export function ticketStatusVariant(value) {
  switch (value) {
    case "open":
      return "info";
    case "in_progress":
      return "info";
    case "waiting_on_customer":
      return "warning";
    case "resolved":
      return "success";
    case "closed":
      return "muted";
    default:
      return "muted";
  }
}

export function formatIso(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleString(undefined, {
      year: "numeric", month: "short", day: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch (_e) {
    return iso;
  }
}
